// frontend/src/services/event.service.ts
import api from './api';
import { Event } from '../types';

class EventService {
  async getCoupleEvents(coupleId: string): Promise<Event[]> {
    try {
      const response = await api.get<Event[]>(`/weddings/events/couple/${coupleId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getEvent(id: string): Promise<Event> {
    try {
      const response = await api.get<Event>(`/weddings/events/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createEvent(eventData: {
    title: string;
    description?: string;
    date: string;
    time?: string;
    location?: string;
    address?: string;
    couple: string;
  }): Promise<Event> {
    try {
      const response = await api.post<Event>('/weddings/events', eventData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateEvent(id: string, eventData: Partial<Event>): Promise<Event> {
    try {
      const response = await api.patch<Event>(`/weddings/events/${id}`, eventData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteEvent(id: string): Promise<void> {
    try {
      await api.delete(`/weddings/events/${id}`);
    } catch (error) {
      throw this.handleError(error);
    }
  }

  private handleError(error: any): Error {
    if (error.response && error.response.data && error.response.data.message) {
      const message = Array.isArray(error.response.data.message)
        ? error.response.data.message.join(', ')
        : error.response.data.message;
      return new Error(message);
    }
    return error instanceof Error ? error : new Error('An unexpected error occurred');
  }
}

export default new EventService();